import type {
  DiscountInteractionStateType,
  GetApplicationDiscountDetailsResponseType
} from '@nw/shared/data-access';

export class DiscountDetailsModel {
  interactionState: DiscountInteractionStateType | null = null;
  couponCode = '';
  discountAmount = 0;
  isGracePeriodApplicable = false;
  expiryDatetime: string | null = null;
  currentDatetime = '';
  gracePeriodMinutes: number | null = null;

  constructor(response: GetApplicationDiscountDetailsResponseType) {
    const { interaction_state, coupon_data } = response;

    this.interactionState = interaction_state;

    if (!coupon_data || interaction_state === null) {
      this.couponCode = '';
      this.discountAmount = 0;
      this.expiryDatetime = null;
      this.currentDatetime = '';
      this.gracePeriodMinutes = null;
      this.isGracePeriodApplicable = false;
      return;
    }

    this.couponCode = coupon_data.coupon_code;
    this.discountAmount = coupon_data.discount_value;
    this.expiryDatetime = coupon_data.expiry_datetime ?? null;
    this.currentDatetime = coupon_data.current_datetime;
    this.gracePeriodMinutes = coupon_data.grace_period_in_mins ?? null;
    this.isGracePeriodApplicable = Boolean(
      coupon_data.is_grace_period_applicable
    );
  }
}
